import { render, staticRenderFns } from "./dueDate.vue?vue&type=template&id=0c2faf90"
import script from "./dueDate.vue?vue&type=script&lang=js"
export * from "./dueDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports